import { useState } from 'react'
import { Channel } from 'stream-chat'
import { modal } from '@codeleap/modals'
import { GroupInfo, EditGroup, AddMembers, MentionsNotifications } from './components'
import { useIsTablet } from '@/hooks'

const pageMap = {
  group_info: GroupInfo,
  add_members: AddMembers,
  edit_group: EditGroup,
  mentions_notifications: MentionsNotifications,
}
type PageName = keyof typeof pageMap

export type GroupDetailsModalProps = {
  channel: Channel
  navigateTo?: (pageName: PageName) => void
  initialPage: PageName
}

export const GroupDetailsModal = modal<GroupDetailsModalProps>({ id: 'group-details-modal' }).content((props) => {
  const isTablet = useIsTablet()
  const [page, setPage] = useState(() => {
    const initialPage = props.initialPage || 'group_info'
    return Object.keys(pageMap).indexOf(initialPage) !== -1 ? Object.keys(pageMap).indexOf(initialPage) : 0
  })

  const CurrentPage = pageMap[Object.keys(pageMap)?.[page]] || GroupInfo

  GroupDetailsModal.useProps({
    showClose: false,
    style: [
      'centered',
      'box:responsiveness',
      (props.initialPage === 'group_info' && isTablet) ? 'fullscreen' : '',
      { box: ['padding:0', { breakpoints: { tabletSmall: ['padding:0'] } }] }
    ],
  })

  function nextPage() {
    setPage((prev) => Math.min(prev + 1, Object.keys(pageMap).length - 1))
  }

  function prevPage() {
    setPage((prev) => Math.max(prev - 1, 0))
  }

  const navigateTo = (pageName: PageName) => {
    const pageIndex = Object.keys(pageMap).indexOf(pageName)
    if (pageIndex !== -1) {
      setPage(pageIndex)
    }
  }

  return <CurrentPage {...props} onNextPage={nextPage} onPrevPage={prevPage} navigateTo={navigateTo} />
})
